import React, { Component } from 'react';
import ScrollFadeIn from "./../../components/scrollFadeIn";
import BannerFadeIn from "./../../components/bannerFadeIn";
import CollectionBanner from "./../../components/collectionBanner";
import Footer from './../../components/footer';
import {Helmet} from "react-helmet";

export default class Press extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>{'Kat Medina | Press'}</title>
          <meta name="description" content="Press kit for Kat Medina. World traveler. Writer. Entrepreneur. Joy finder. Author of the book, The Joys of Jet Lag." />
        </Helmet>
        <BannerFadeIn>
          <CollectionBanner
            mobileOptimize={true}
            image={'/images/press-hero.jpg'}
            subtitle={'Kat Medina'}
            title={'Media Kit'}
          />
        </BannerFadeIn>
        <ScrollFadeIn>
          <div className="large-padding">
            <div className="max-width-container">
              <div className="row">
                <div className="small-12 medium-4 background-image-fill" style={{backgroundImage:"url(/images/katmedina-headshot-vertical.jpg)"}}>
                  <img className="full-width" style={{opacity:0}}  src="/images/katmedina-headshot-vertical.jpg" />
                </div>
                <div className="small-12 medium-8">
                  <p className="tiny-padding">{'Entrepreneur, world traveler, and public speaker, Kat Medina is the author of The Joys of Jet Lag: How to Use a Traveler’s Mindset to Not be an A-Hole in Daily Life. She’s traveled to more than 35 countries, and lived in Ecuador, Argentina, France, and Spain. Kat draws upon her passion for travel to inspire joy in others, teaching people how to show up and live fully by embodying a traveler’s mindset in daily life. She currently lives in South Lake Tahoe, California with her husband, son, and giant Golden Retriever named Donut.'}</p>
                  <div className="full-width tiny-padding">
                    <div className="row">
                      <div className="small-4 medium-2" style={{padding:"2px"}}>
                        <a download href="/images/katmedina-headshot-2.jpg">
                          <div className="background-image-fill" style={{backgroundImage:"url(/images/katmedina-headshot-2.jpg)"}}>
                            <img className="full-width" style={{opacity:0}}  src="/images/square.png" />
                          </div>
                        </a>
                      </div>
                      <div className="small-4 medium-2" style={{paddingRight:"2px"}}>
                        <a download href="/images/katmedina-headshot-3.jpg">
                          <div className="background-image-fill" style={{backgroundImage:"url(/images/katmedina-headshot-3.jpg)"}}>
                            <img className="full-width" style={{opacity:0}}  src="/images/square.png" />
                          </div>
                        </a>
                      </div>
                      <div className="small-4 medium-2" style={{padding:"2px"}}>
                        <a download href="/images/katmedina-headshot-vertical.jpg">
                          <div className="background-image-fill" style={{backgroundImage:"url(/images/katmedina-headshot-vertical.jpg)"}}>
                            <img className="full-width" style={{opacity:0}}  src="/images/square.png" />
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="tiny-padding">
                    <a download href="/zip/katmedina.zip">
                      <div className="button primary-background white">{'Download Media Kit'}</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ScrollFadeIn>
        <Footer />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/press/index.js